

















import { Component, Mixins, Watch } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import {
  ISize,
} from "../../../../../../base/domain/drawing";
import {
  FormatStructureEditorStoreReferableMixin,
  CommonComponentsAccessibleMixin,
  UploadImageFileMixin,
} from "../../mixins";
import { DomainRegistry } from "../../../../../domain";
import {
  IFormatObjectTemporaryImage,
} from "../../../../../domain/editableFormat";
import SingleFlowLayoutSelector from "../../../../../../base/components/system/selectors/SingleFlowLayoutSelector.vue";
import {
  AbstractImageDrawableObjectEditor,
} from "../../../../../domain/editableFormat/objectEditors";
import {
  IImageDrawableObject,
} from "../../../../../domain/editableFormat/objects";
import {
  instanceOfIPresentableFixedAspectRatio,
} from "../../../../../domain/editableFormat/properties";

@Component({
  components: {
    SingleFlowLayoutSelector,
  }
})
export default class FormatObjectTemporaryImageUploader extends Mixins(FormatStructureEditorStoreReferableMixin, CommonComponentsAccessibleMixin, ModelEditableMixin, UploadImageFileMixin) {
  writePropertyWhenValid: (writer: (source: AbstractImageDrawableObjectEditor<IImageDrawableObject>) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: AbstractImageDrawableObjectEditor<IImageDrawableObject>) => T, defaultValue: T) => T;

  selectedTemporaryImage: IFormatObjectTemporaryImage = null;

  $refs!: {
    input: HTMLInputElement,
  };

  mounted() {
    this.selectedTemporaryImage = this.editingTemporaryImage;
  }

  get temporaryImages(): IFormatObjectTemporaryImage[] {
    return this.storePresenter.getTemporaryImages();
  }

  get editingTemporaryImage(): IFormatObjectTemporaryImage {
    return {
      imageGuid: this.readPropertyOrDefault(s => s.temporaryImageContent().getValue().guid, null),
      size: this.readPropertyOrDefault(s => s.size().getValue(), null)
    };
  }
  
  set editingTemporaryImage(value: IFormatObjectTemporaryImage) {
    this.writePropertyWhenValid(s => {
      if (value) {
        if (instanceOfIPresentableFixedAspectRatio(s)) {
          s.size().setValue(value.size);
        }
        s.temporaryImageContent().setValue({
          guid: value.imageGuid,
          isEnable: true,
        });
      } else {
        s.temporaryImageContent().setValue({
          guid: null,
          isEnable: false,
        });
      }
    });
  }

  @Watch("selectedTemporaryImage")
  onSelectedTemporaryImageUpdated(newValue: IFormatObjectTemporaryImage, oldValue: IFormatObjectTemporaryImage): void {
    if (this.equivalentValidator(newValue, this.editingTemporaryImage)) {
      return;
    }
    this.editingTemporaryImage = newValue;
  }

  @Watch("editingTemporaryImage")
  onEditingTemporaryImageUpdated(newValue: IFormatObjectTemporaryImage, oldValue: IFormatObjectTemporaryImage): void {
    if (this.equivalentValidator(newValue, this.selectedTemporaryImage)) {
      return;
    }
    this.selectedTemporaryImage = newValue;
  }

  uploadedImage(imageGuid: string, size: ISize<number>, fileName: string): void {
    this.getCommonComponents().getStoreEditor().setTemporaryImages(
      [{ imageGuid: imageGuid, size: size, }].concat(this.temporaryImages)
    );
  }

  openDialog(): void {
    this.$refs.input.click();
  }

  toImageStyle(value: IFormatObjectTemporaryImage): any {
    return value
      ? {
        width: "96px",
        height: "96px",
        backgroundImage: "url(" + this.toImageSource(value) + ")",
      }
      : null;
  }

  private toImageSource(image: IFormatObjectTemporaryImage): string {
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    const imageSource = repository.getTemporaryImageSource(image.imageGuid);
    return imageSource.source;
  }

  equivalentValidator(source: IFormatObjectTemporaryImage, destination: IFormatObjectTemporaryImage): boolean {
    return !!source === !!destination &&
      source.imageGuid === destination.imageGuid;
  }
}
